// extracted by mini-css-extract-plugin
export default {"searchBar":"Search_searchBar__2vZp6","icon":"Search_icon__MyD8Y"};